import * as React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { chunks, getDaysInMonth, isStartOfRange, isEndOfRange, inDateRange, isRangeSameDay } from '../utils';
import { NavigationAction } from '../types';
import Day from './Day';
import Header from './Header';
import moment from 'moment';
const WEEK_DAYS = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
const Month = props => {
    const { helpers, handlers, value: date, dateRange, marker, setValue: setDate, minDate, maxDate } = props;
    const [back, forward] = props.navState;
    return (<Box sx={{
            width: '290px'
        }}>
      <Grid container>
        <Header date={date} setDate={setDate} nextDisabled={!forward} prevDisabled={!back} onClickPrevious={() => handlers.onMonthNavigate(marker, NavigationAction.Previous)} onClickNext={() => handlers.onMonthNavigate(marker, NavigationAction.Next)}/>

        <Grid item container direction='row' sx={{
            justifyContent: 'space-around',
            mt: 2,
            pl: 1,
            pr: 1
        }} component={'div'}>
          {WEEK_DAYS.map(day => (<Typography color='textSecondary' key={day} variant='caption'>
              {day}
            </Typography>))}
        </Grid>

        <Grid item container direction='column' sx={{
            pl: 1,
            pr: 1,
            mt: 2,
            mb: 2
        }} component={'div'}>
          {chunks(getDaysInMonth(date), 7).map((week, idx) => (<Grid key={idx} container direction='row' sx={{ mt: 1, mb: 1 }}>
              {week.map(day => {
                const isStart = isStartOfRange(dateRange, day);
                const isEnd = isEndOfRange(dateRange, day);
                const isRangeOneDay = isRangeSameDay(dateRange);
                const highlighted = inDateRange(dateRange, day) || helpers.inHoverRange(day);
                return (<Day key={moment(day).format('DD-MM-YYYY')} filled={isStart || isEnd} outlined={moment().isSame(day, 'day')} highlighted={highlighted && !isRangeOneDay} disabled={!moment(date).isSame(day, 'month') || !moment(day).isBetween(minDate, maxDate, undefined, '[]')} startOfRange={isStart && !isRangeOneDay} endOfRange={isEnd && !isRangeOneDay} onClick={() => handlers.onDayClick(day)} onHover={() => handlers.onDayHover(day)} value={moment(day).date()}/>);
            })}
            </Grid>))}
        </Grid>
      </Grid>
    </Box>);
};
export default Month;
